const tabs = {
    platform_settings: '平台設定',
    actions: '流程擴充',
    get_started: '開始上手',
    dashboard: '儀表板',
    applications: '全部應用',
    api_resources: '介面資源',
    sign_in_experience: '登入與帳戶',
    connectors: '連接器',
    enterprise_sso: '企業單一登入',
    security: '安全',
    webhooks: '事件回呼',
    organizations: '組織',
    users: '使用者管理',
    audit_logs: '稽核日誌',
    roles: '角色',
    docs: '文件',
    tenant_settings: '租戶設定',
    mfa: '多重驗證',
    customize_jwt: '自訂JavaScript物件表示法（JSON）網路權杖（JWT）',
    signing_keys: '簽署金鑰',
    organization_template: '組織範本',
};
export default Object.freeze(tabs);
